<template>
  <div>
    <div class="login">
      <div
        style="padding:20px 20px;
    text-align: left;
    display: flex;
    align-items: center;font-weight:bold;"
        @click="goback"
      >
        <mu-icon value="arrow_back"></mu-icon>
        
      </div>
      <dl class="user-title">
        <dd>重置密码</dd>
      </dl>

      <div class="user-form">
        <mu-text-field full-width  v-model="phone" placeholder="请输入手机号码"></mu-text-field>
        <mu-text-field full-width type="password" v-model="password1" placeholder="请输入新的密码"></mu-text-field>
        <mu-text-field full-width type="password" v-model="password2" placeholder="请再次输入新的密码"></mu-text-field>
        <div style="width: 100%;align-items: center;
    display: flex;
    text-align: left;"></div>
        <br />
        <mu-button color="primary" :disabled="!canRegister" full-width @click="submit">提交</mu-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
export default {
  data() {
    return {
      acceptXiyi: true,
      phone:"",
      password1: "",
      password2: ""
    };
  },
  computed: {
    canRegister() {
      if (this.password1.length < 6) {
        return false;
      }
      return this.acceptXiyi && this.password1 == this.password2;
    }
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    goback() {
      this.$router.go(-1);
    },
    submit() {
      if(!this.$store.state.user) {
        this.$router.push("/login")
        return
      }
      if(this.$store.state.user.phone != this.phone ){
        this.$toast("请输入正确的手机号")
        return
      }
      Api.resetpass(this.password1).then(res => {
        this.$indicator.close();
        if (!res.data.hasOwnProperty("error")) {
          this.$toast("修改密码成功");
        } else {
          this.$toast(res.data.error);
        }
      });
    }
  }
};
</script>

<style scoped>
.user-top {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.user-title {
  padding: 40px 20px;
  width: 50%;
  text-align: left;
  font-size: 2rem;
}
.user-form {
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.myinput {
  height: 50px;
  width: 80%;
  border: gray;
}
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/ResetPass.vue